import React from 'react';
import IconButton from 'material-ui/IconButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {
	withRouter,
} from 'react-router-dom';

import {
	Grid,
	Icon,
} from '../../components';
import {
	categoriaService,
	Utils,
} from '../../services';

class Categorias extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			dsCategorias: [],
		};
	}

	async componentWillMount() {
		await this.updateCategorias();
	}

	async updateCategorias() {
		const categorias = await categoriaService.getCategorias(this.props.subevento);
		this.setState({ dsCategorias: categorias });
	}

	async delete(codigo) {
		if (window.confirm('Deseja excluir a categoria?')) {
			try {
				const _csrf = (await categoriaService.categoriaForm()).token;
				const response = await categoriaService.delete({ codigo, _csrf });
				this.updateCategorias();
				Utils.showToast(response.message);
			} catch (e) {
				Utils.showToast(e.message);
			}
		}
	}

	async newCategoria() {
		this.props.history.push(`/categorias/add/${this.props.subevento}`);
	}

	render() {
		const {
			dsCategorias,
		} = this.state;

		return (
			<div>
				<Grid
					ref={ref => this.categoriasGridRef = ref}
					columnSortDefault={0}
					textTableEmpty="Nenhuma categoria encontrada."
					showSearch={false}
					dataSource={dsCategorias}
					columns={[
						{ text: "Nome", name: "NOME", allowSort: true, allowSearch: true, searchOperator: 'LIKE' },
						{ text: "Descricao", name: "DESCRICAO", allowSort: true, allowSearch: true, searchOperator: 'LIKE' },
						{
							name: (item) => {
								return (
									<div>
										<IconButton onClick={() => this.props.history.push(`/categorias/add/${this.props.subevento}/${item.CODIGO}`)}>
											<Icon name="edit" />
										</IconButton>
										<IconButton onClick={() => this.delete(item.CODIGO)}>
											<Icon name="delete" />
										</IconButton>
									</div>
								);
							}
						},
					]} />
				<div className="fab-buttons-eventos">
					<FloatingActionButton onClick={() => this.newCategoria()} mini={true}>
						<ContentAdd />
					</FloatingActionButton>
				</div>
			</div>
		);
	}
}

export default withRouter(Categorias);
